var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8488 3.15175C20.3802 2.68314 19.6204 2.68314 19.1518 3.15175L11.1518 11.1518C10.6831 11.6204 10.6831 12.3802 11.1518 12.8488C11.6204 13.3174 12.3802 13.3174 12.8488 12.8488L18.8003 6.89735V25.3333C18.8003 25.996 19.3376 26.5333 20.0003 26.5333C20.663 26.5333 21.2003 25.996 21.2003 25.3333V6.89735L27.1519 12.8488C27.6204 13.3174 28.3802 13.3174 28.8487 12.8488C29.3175 12.3802 29.3175 11.6204 28.8487 11.1518L20.8488 3.15175ZM6.66683 26.6667C7.4032 26.6667 8.00016 27.2635 8.00016 28.0001V32.0001C8.00016 33.4769 9.18856 34.6667 10.6571 34.6667H29.3367C30.8079 34.6667 32.0002 33.4742 32.0002 32.0001V28.0001C32.0002 27.2635 32.5972 26.6667 33.3335 26.6667C34.0698 26.6667 34.6668 27.2635 34.6668 28.0001V32.0001C34.6668 34.9441 32.2834 37.3334 29.3367 37.3334H10.6571C7.70734 37.3334 5.3335 34.9414 5.3335 32.0001V28.0001C5.3335 27.2635 5.93046 26.6667 6.66683 26.6667Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.4d59c71fafeed55b17eaf7b2d401b4ff.svg";
export { ForwardRef as ReactComponent };